import {setUpLoggingService} from '../services/logging/index';

Hop.defineModule('logging-service', (domRoot, cfg) => {
    setUpLoggingService(cfg);
});
